import $ from "jquery";
import app, { csl, vuwer } from "@@assets/scripts/common";

vuwer.get("body").setProp({
	onReady($self) {
		const $form = $self.find("form");
		if(!$form.length) {
			return false;
		}
		
		csl.log.orange("** this page has form", { $form });
		
		const [deviceType] = app.device;
		if(deviceType === "sp") {
			$form.find("input").each((i, elm) => {
				const dataType = $(elm).attr("data-type");
				if(dataType) {
					elm.type = dataType;
				}
			});
		}
		
		this.setProp({ $form });
	}
});
